import { RolesList } from '../../../../../models/rolesList.model';
import { RoleType } from '../../../../../shared/enums/role-type/role-type.module';
import { AfterViewChecked, AfterViewInit, Component, ElementRef, EventEmitter, HostListener, Input, Output, SimpleChanges, ViewChild } from '@angular/core';
import { Role } from '../../../../../models/role.model';
import { MatTable } from '@angular/material/table';
import { Accessibility } from '../../../../../models/accessibility.model';
import { DialogService } from '../../../../../services/shared/dialog/dialog.service';
import { TranslationService } from '../../../../../services/translation/translation.service';
import { ComponentType } from '../../../../../shared/enums/component-type/component-type.module';
import { UtilsService } from '../../../../../services/shared/utils/utils.service';
import { MatDialog } from '@angular/material/dialog';
import { MultiActionModalComponent } from '../../../../../shared/components/multi-action-modal/multi-action-modal.component';
import { AngularEditorConfig } from '@wfpena/angular-wysiwyg';
import { EditorI18nService } from '../../../../../services/editor-i18n/editor-i18n.service';
@Component({
  selector: 'app-roles',
  templateUrl: './roles.component.html',
  styleUrl: './roles.component.css'
})
export class RolesComponent implements AfterViewChecked {
  @Input() id: string | undefined;
  @Input() roles!: Role[];
  @Input() fullRoles!: RolesList[];
  @Input() type!: string;
  @Input() isEditColumnVisible!: boolean;

  @Output() customerNotVisible = new EventEmitter<string>();
  @Output() rolesChanged = new EventEmitter<{ type: string, roleType: RoleType }>();

  ComponentType = ComponentType;

  RoleType = RoleType;
  @ViewChild(MatTable) table!: MatTable<Role>;
  @ViewChild('editorTextArea', { read: ElementRef }) editorEl!: ElementRef<HTMLElement>;
  translated = false;
  currentRole: Role | undefined;
  private _editorText = '';

  get editorText() {
    return this._editorText;
  }

  set editorText(value: string) {
    this._editorText = value;
    this.currentRole!.guide = value;
  }

  constructor(
    private dialogService: DialogService,
    private translationService: TranslationService,
    private utils: UtilsService,
    private dialogMat: MatDialog,
    private editorI18n: EditorI18nService
  ) { }
  config: AngularEditorConfig = {
    editable: true,
    sanitize: false,
    outline: false,
    height: 'auto',
    minHeight: '75px',
    spellcheck: false,
    toolbarHiddenButtons: [
      ['insertVideo', 'insertImage', 'fontName']
    ],
    defaultFontSize: '2',
    defaultFontName:'"Poppins", sans-serif',
    enableToolbar: true,
    placeholder: ''
  };
  ngAfterViewChecked(): void {
    if (this.translated) return;

    const toolbarExists = document.querySelector('.angular-editor-toolbar');
    if (!toolbarExists) return;

    this.editorI18n.translateAll();
    this.translated = true;
  }

  ngOnInit() {

  }
  ngOnChanges(changes: SimpleChanges) {
    if (changes['id']) {
      this.currentRole = undefined;
    }
  }

  getDisplayedColumns() {

    var list = ['name', 'visible'];

    if (this.isEditColumnVisible) {
      list.push('editable');
    }

    if(this.type == 'page')
    {
      list.push('submittable')
    }

    if(this.type != 'page'){
      list.push('actions')
    }

    if(this.type == 'page' || this.type == 'block')
    {
      list.push('guidable')
    }

    return list;
  }

  getDefaultAccessibility(roleType: RoleType): Accessibility | undefined {
    const typePriority = this.getTypePriority(this.type);
    for (const type of typePriority) {
      const accessibility = this.fullRoles.find((x: RolesList) => x.type === type)?.list.find((y: Role) => y.name === roleType && y.isActive)?.accessibility;
      if (accessibility) {
        return accessibility;
      }
    }
    return undefined;
  }

  getTypePriority(currentType: string): string[] {
    switch (currentType) {
      case 'component':
        return ['block', 'page'];
      case 'block':
        return ['page'];
      default:
        return [];
    }
  }

  onChange(roleType: RoleType, value: boolean, checkbox: string): void {
    var role = this.roles.find((x: Role) => x.name == roleType);
    var roleOnFullList = this.fullRoles.find((x: RolesList) => x.type == this.type)?.list.find((y: Role) => y.name == roleType);

    if (role !== undefined && roleOnFullList) {

      const updateRoles = () => {
        if (checkbox === "editable") {
          role!.accessibility.editable = value;
          roleOnFullList!.accessibility.editable = value;
          if (value) {
            role!.accessibility.visible = value;
            roleOnFullList!.accessibility.visible = value;
          }
        } else if (checkbox === "visible") {
          role!.accessibility.visible = value;
          roleOnFullList!.accessibility.visible = value;
        }
        else if (checkbox === "submittable") {
          role!.accessibility.submittable = value;
          roleOnFullList!.accessibility.submittable = value;
        }
        this.rolesChanged.emit({ type: this.type, roleType: roleType });
      };

      if (roleType === RoleType.CUSTOMER && !value && checkbox === "editable") {
        const baseMessage = this.type === 'component'
          ? this.translationService.translate('You are about to modify the keyIndicator weights for this component.')
          : this.translationService.translate('You are about to modify the keyIndicator weights for all components.');
        const message = `${baseMessage} ${this.translationService.translate('What would you like to do?')}`;

        this.openMultiActionModal(message).subscribe(result => {
          switch (result) {
            case 'Cancel':
              role!.accessibility.editable = true;
              roleOnFullList!.accessibility.editable = true;
              break;

            case 'Keep':
              role!.isActive = true;
              roleOnFullList!.isActive = role!.isActive;
              updateRoles();
              break;

            case 'Clear':
              role!.isActive = true;
              roleOnFullList!.isActive = role!.isActive;
              this.customerNotVisible.emit(this.type);
              updateRoles();
              break;
          }
        });
      } else {
        role.isActive = true;
        roleOnFullList.isActive = role.isActive;
        updateRoles();
      }
    }
  }

  onRemoveRole(roleType: RoleType): void {
    var role = this.roles.find((x: Role) => x.name === roleType);
    var roleOnFullList = this.fullRoles.find((x: RolesList) => x.type == this.type)?.list.find((y: Role) => y.name == roleType);

    if (role && roleOnFullList) {

      const defaultAccessibility = this.getDefaultAccessibility(roleType);

      if (defaultAccessibility) {
        const updateRolesAndEmit = () => {
          role!.accessibility.editable = defaultAccessibility.editable;
          role!.accessibility.visible = defaultAccessibility.visible;

          roleOnFullList!.accessibility.editable = defaultAccessibility.editable;
          roleOnFullList!.accessibility.visible = defaultAccessibility.visible;

          this.rolesChanged.emit({ type: this.type, roleType: roleType });
        };

        if (roleType === RoleType.CUSTOMER && role.accessibility.editable !== defaultAccessibility.editable && defaultAccessibility.editable === false) {
          const baseMessage = this.type === 'component'
            ? this.translationService.translate('You are about to modify the keyIndicator weights for this component.')
            : this.translationService.translate('You are about to modify the keyIndicator weights for all components.');
          const message = `${baseMessage} ${this.translationService.translate('What would you like to do?')}`;

          this.openMultiActionModal(message).subscribe(result => {
            switch (result) {
              case 'Cancel':
                return;

              case 'Keep':
                role!.isActive = false;
                roleOnFullList!.isActive = role!.isActive;
                updateRolesAndEmit();
                break;

              case 'Clear':
                role!.isActive = false;
                roleOnFullList!.isActive = role!.isActive;
                this.customerNotVisible.emit(this.type);
                updateRolesAndEmit();
                break;
            }
          });
        } else {
          role.isActive = false;
          roleOnFullList.isActive = role.isActive;
          updateRolesAndEmit();
        }
      }
    }
  }

  private openMultiActionModal(message: string) {
    return this.dialogMat.open(MultiActionModalComponent, {
      autoFocus: false,
      width: '500px',
      data: {
        title: 'Attention',
        message,
        actions: [
          { label: 'Cancel', colored: false },
          { label: 'Keep', colored: true },
          { label: 'Clear', colored: false }
        ]
      }
    }).afterClosed();
  }

  onClickGuidableCheckbox(roleSelected: Role) {
    this.currentRole = roleSelected;

    if (this.currentRole) {
      this._editorText = this.InitEditor(this.currentRole!.guide);
    }
  }

  fixGuideText(event: Event) {
    if (this.currentRole && this.currentRole.guide) {
      this.currentRole.guide = this.utils.beautifyHtml(this.currentRole.guide);
      setTimeout(() => {
        this.utils.adjustTextareaHeight(event.target as HTMLTextAreaElement);
      }, 0);
    }
  }

  adjustTextareaHeight(event: Event): void {
    this.utils.adjustTextareaHeight(event.target as HTMLTextAreaElement);
  }

  onClickCleanGuide() {
    if (this.currentRole) {
      this.dialogService.confirm(this.translationService.translate('Attention'), this.translationService.translate('Are you sure you want to clean this guide text?'))
        .then((confirmed) => {
          if (confirmed) {
            this.currentRole!.guide = "";
            this._editorText = this.InitEditor(this.currentRole!.guide);
          }
        });
    }
  }

  InitEditor(text: string | undefined): string {
    if (text && text.trim().length > 0) {
      return text + '';
    } else {
      return '<span style="font-size: small;"></span>';

    }
  }

  private isCleaning = false;
  onEditorChange(html: string): void {
    if (this.isCleaning) return;

    setTimeout(() => {
      const root = this.editorEl?.nativeElement;
      if (!root) return;

      const toggleBtn = root.querySelector('#toggleEditorMode-');
      if (toggleBtn?.classList.contains('active')) return;

      const editable = root.querySelector('.angular-editor-textarea') as HTMLElement;
      if (!editable) return;

      editable.querySelectorAll<HTMLElement>('h1,h2,h3,h4,h5,h6')
        .forEach(h => {
          h.style.removeProperty('font-size');
          h.querySelectorAll<HTMLElement>('*')
            .forEach(child => child.style.removeProperty('font-size'));
        });

      this.isCleaning = true;
      this._editorText = editable.innerHTML;
      this.currentRole!.guide = editable.innerHTML;
      this.isCleaning = false;
    });
  }
}
